export default "__VITE_ASSET__772ceafa__"